import ServiceDiscovery from 'fb-utils/serviceDiscovery';
window.serviceDiscovery = new ServiceDiscovery(window.CldBzConfig.Registry, window.CldBzConfig.Deployment, window.CldBzConfig.Deployment, {});
